import { useEffect } from 'react';
import {
  getFavorites,
  saveFavorite as saveFavoriteFetch,
  deleteFavorite as deleteFavoriteFetch,
} from 'utils/favorites';
import { useCallback } from 'react';
import { track } from 'utils/tracking';
import trackingEvents from 'utils/trackingEvents';
import { updateFavorites, useUiValue } from 'stores/uiContext';
import trackAnalyticsEvent from 'utils/trackAnalyticsEvent';

const trackFavoriteClick = () => {
  trackAnalyticsEvent({
    gtagEvent: 'FavoriteClick',
    mouseflowTag: 'Favorite',
  });
};

const useFavorites = () => {
  const [{ favoritesList }, dispatch] = useUiValue();

  useEffect(() => {
    if (
      window.performance.navigation.type ===
      PerformanceNavigation.TYPE_BACK_FORWARD
    ) {
      window.location.reload();
    }
    // console.log({favoritesList})
    getFavorites().then((res) => {
      if (res) dispatch(updateFavorites(res));
      else dispatch(updateFavorites([]));
    });
  }, []);

  const saveFavorite = useCallback(
    (id) => {
      track({ eventId: trackingEvents.Favorites });
      trackFavoriteClick();
      dispatch(updateFavorites([...favoritesList, id]));

      saveFavoriteFetch(id).then((res) => {
        dispatch(updateFavorites(res));
      });
    },
    [favoritesList],
  );

  const deleteFavorite = useCallback(
    (id) => {
      if (Array.isArray(favoritesList)) {
        dispatch(updateFavorites(favoritesList.filter((f) => f !== id)));
      }

      deleteFavoriteFetch(id).then((res) => {
        dispatch(updateFavorites(res));
      });
    },
    [favoritesList],
  );

  return { favoritesList, saveFavorite, deleteFavorite };
};
export default useFavorites;
